export default __webpack_public_path__ + "static/media/crystal.13f66e10.png";